<template>
  <div id="app">
    <headers @external="external" @clientWidth="clientWidth" />

    <router-view />
    <footers />
  </div>
</template>
<script>
import { Swiper, SwiperSlide, directive } from "vue-awesome-swiper";
import headers from "@/components/header";
import footers from "@/components/footer";
import "swiper/css/swiper.css";
export default {
  name: "App",
  components: {
    SwiperSlide,
    Swiper,
    footers,
    headers,
  },
  directives: {
    swiper: directive,
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  data() {
    return {
      width: document.body.clientWidth,
    };
  },
  created() {
    // window.localStorage.setItem("language", language);
    window.localStorage.getItem("language") == null
      ? window.localStorage.setItem("language", "cn")
      : window.localStorage.getItem("language");
  },
  methods: {
    clientWidth(width) {
      this.width = width;
    },
    external(id) {
      document.getElementById(id).scrollIntoView({
        block: "start",
        inline: "nearest",
        behavior: "smooth",
        alignTo: false,
      });
    },
  },
};
</script>
<style lang="scss">
@import "./css/common.css";
@import "./css/flex.css";
@import "./scss/common.scss";
@import "./css/fonts.css";

#app {
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC,
    Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial,
    sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  // text-align: center;
  padding: 0;
  margin: 0;
}

body {
  margin: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue